import React from "react"
import { Link } from "gatsby"
import CalendlyModal from "../CalendlyModal"
import ContactUsModal from "../ContactUsModal"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import {
  FaFacebookSquare,
  FaTwitterSquare,
  FaLinkedin,
  FaYoutube,
  FaPhone,
} from "react-icons/fa"
import { IoIosMail } from "react-icons/io"

export default function Footer() {
  return (
    <footer className="zenduty-footer bg-dark text-light bg-slope-top pt-8 sm:pt-0 pb-8">
      <div className="container">
        <div className="flex flex-wrap justify-between mb-8">
          <FooterLinksContainer>
            <FooterLinksTitle>Product</FooterLinksTitle>
            <FooterLinks>
              <FooterLink href="https://blog.zenduty.com/">Blog</FooterLink>
              <FooterLink href="https://docs.zenduty.com/">
                Integrations
              </FooterLink>
              <FooterLink href="http://status.zenduty.com/">
                Status page
              </FooterLink>
              <FooterLink href="http://zenduty.freshdesk.com/">
                Support page
              </FooterLink>
              <FooterLink internal href="/pricing/">
                Pricing
              </FooterLink>
              <FooterLink href="https://trello.com/b/1gBqXdvx/zenduty-upcoming-features">
                Product updates
              </FooterLink>
              <FooterLink href="https://engineering.zenduty.com/">
                Engineering Blog
              </FooterLink>
            </FooterLinks>
          </FooterLinksContainer>

          <FooterLinksContainer>
            <FooterLinksTitle>Resources</FooterLinksTitle>
            <FooterLinks>
              <FooterLink href="https://apidocs.zenduty.com/">API</FooterLink>
              <FooterLink href="https://docs.zenduty.com/">
                User Documentation
              </FooterLink>
              <FooterLink internal href="/privacy/">
                Privacy Policy
              </FooterLink>
              <FooterLink internal href="/gdpr/">
                GDPR
              </FooterLink>
              <FooterLink internal href="/terms/">
                Terms of Service
              </FooterLink>
              <FooterLink
                internal
                href="/zenduty-the-best-pagerduty-alternative-compare/"
              >
                Compare with Pagerduty
              </FooterLink>
              <FooterLink
                internal
                href="/zenduty-the-best-opsgenie-alternative-compare/"
              >
                Compare with OpsGenie
              </FooterLink>
              <FooterLink
                internal
                href="/zenduty-the-best-victorops-alternative-compare/"
              >
                Compare with VictorOps
              </FooterLink>
            </FooterLinks>
          </FooterLinksContainer>

          <FooterLinksContainer>
            <FooterLinksTitle>About</FooterLinksTitle>
            <FooterLinks>
              <FooterLink internal href="/team/">
                Team
              </FooterLink>
              <FooterLink href="https://www.angel.co/yellowant/">
                Investors
              </FooterLink>
              <FooterLink href="https://angel.co/company/yellowant/">
                Careers
              </FooterLink>
              <ContactUsModal>
                <FooterLink>
                  <span className="cursor-pointer"> Contact us</span>
                </FooterLink>
              </ContactUsModal>
              <FooterLink internal href="/terms/">
                Terms of Service
              </FooterLink>
            </FooterLinks>
          </FooterLinksContainer>

          <FooterLinksContainer>
            <FooterLinksTitle>Let's Talk</FooterLinksTitle>
            <FooterLinks>
              <FooterLink href="https://www.twitter.com/Zenduty/">
                Twitter
              </FooterLink>
              <FooterLink href="https://www.facebook.com/zendutyhq/">
                Facebook
              </FooterLink>
              <FooterLink href="https://www.github.com/zenduty/">
                Github
              </FooterLink>
              <ContactUsModal>
                <FooterLink className="mt-10">
                  <span className="cursor-pointer"> Contact us</span>
                </FooterLink>
              </ContactUsModal>
              <FooterLink className="link" href="mailto:vishwa@yellowant.com">
                Email us
              </FooterLink>
              <CalendlyModal>
                <span className="cursor-pointer link">Schedule a Demo</span>
              </CalendlyModal>
            </FooterLinks>
          </FooterLinksContainer>
        </div>
        <div className="flex flex-row justify-center pb-2 ">
          <OutboundLink
            href="https://www.facebook.com/zendutyhq/"
            aria-label="Click here To visit Zenduty Facebook page"
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
          >
            <FaFacebookSquare className="text-2xl cursor-pointer hover:text-brand m-6" />
          </OutboundLink>
          <OutboundLink
            href="https://twitter.com/zenduty"
            aria-label="Click here To visit Zenduty Twitter page"
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
          >
            <FaTwitterSquare className="text-2xl cursor-pointer  hover:text-brand m-6" />
          </OutboundLink>
          <OutboundLink
            href="https://www.linkedin.com/company/zenduty/"
            aria-label="Click here To visit Zenduty LinkedIn page"
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
          >
            <FaLinkedin className="text-2xl cursor-pointer hover:text-brand m-6" />
          </OutboundLink>
          <OutboundLink
            href="https://www.youtube.com/channel/UCH0SJFh6Yo4gMcZqyjx2WtA"
            aria-label="Click here To visit Zenduty Youtube page"
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
          >
            <FaYoutube className="text-2xl cursor-pointer hover:text-brand m-6" />
          </OutboundLink>
        </div>
        <div className="text-center">
          <OutboundLink
            href="tel:+1 408 521 1217"
            aria-label="Contact us Phone Number"
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
          >
            {" "}
            <FaPhone className=" inline text-xl mb-1" />
            &nbsp; Enquiries at: +1 408 521 1217
          </OutboundLink>
        </div>
        <div className="text-center py-2">
          <OutboundLink
            href="mailto:contact@zenduty.com"
            aria-label="Contact us Email"
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
          >
            <IoIosMail className="text-2xl inline mb-1" />
            &nbsp; Email us
          </OutboundLink>
        </div>

        <div className="text-center">
          Copyright &copy; 2020 Zenduty. Product of{" "}
          <OutboundLink
            href="https://www.yellowant.com/"
            aria-label="Click here To visit the YellowAnt page."
            target="_blank"
            rel="noopener noreferrer"
            className="text-secondary"
          >
            YellowAnt
          </OutboundLink>
          .
        </div>
      </div>
    </footer>
  )
}

function FooterLinksContainer({ children }) {
  return <section className="p-8">{children}</section>
}

function FooterLinksTitle({ children }) {
  return <h4 className="font-bold mb-2">{children}</h4>
}

function FooterLinks({ children }) {
  return <ul>{children}</ul>
}

function FooterLink({ children, internal, href, ...props }) {
  return (
    <li className="leading-loose text-subtle mb-2" {...props}>
      {internal ? (
        <Link to={href}>{children}</Link>
      ) : (
        <OutboundLink href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </OutboundLink>
      )}
    </li>
  )
}
